import { Component, OnInit, Optional } from '@angular/core';
import { SideNavService } from '../../layouts/side-menu/sidenav/sidenav.service';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AccountService } from '../../account/account.service'
import { AngularFireDatabase } from '@angular/fire/database';
import { formatDate } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-device-troubleshot',
  templateUrl: './device-troubleshot.component.html',
  styleUrls: ['./device-troubleshot.component.css']
})
export class DeviceTroubleshotComponent implements OnInit {

  constructor(private sideNavService: SideNavService, private accountService: AccountService,
    private router: ActivatedRoute, private spinner: NgxSpinnerService, @Optional() private firebase: AngularFireDatabase) {
  }

  deviceId;
  error
  deviceArray = []
  rawData
  rawActuatorData
  connectedSensor = []
  connectedActuator = []
  isRawDataError = false
  validity = false
  inputRaw
  inputValidation = false
  expectedFormat
  sensorInDevice
  actuatorInDevice
  rawDataTemplate
  newSensorData
  currentTime
  sensorValue
  lastRawDataValue

  ngOnInit() {

    this.router.params.subscribe(params => {
      this.deviceId = params['deviceId'];
    });
    this.spinner.show();

    this.getDeviceData()
    if (environment.useFirebase) {
      this.getDataFromFirebase();
    }
  }

  isSideNavVisible() {
    return this.sideNavService.isSideNavVisible;
  }

  getDeviceData() {
    this.accountService.getDevice(this.deviceId)
      .subscribe(res => {
        this.deviceArray = res.content
        this.rawData = res.content.lastRawData || '';
        this.rawActuatorData = res.content.lastRawActuatorData || '';
        this.isRawDataError = !res.content.lastRawData && !res.content.lastRawActuatorData;
        this.connectedSensor = res.content.sensorCodes
        this.sensorInDevice = res.content.sensors

        this.actuatorInDevice = res.content.actuators
        this.connectedActuator = res.content.actuatorCodes
        this.spinner.hide()
        this.createExpectedMessageFormat(res.content.sensorCodes, res.content.actuatorCodes)
        this.deviceRowData(res.content.lastRawData)

        const sensorDataValid = this.lastRawDataValidation(
          this.deviceRowData(res.content.lastRawData),
          this.deviceRowData(this.expectedFormat)
        );
        const actuatorDataValid = this.lastRawDataValidation(
          this.deviceRowData(res.content.lastRawActuatorData),
          this.deviceRowData(this.expectedFormat)
        );

        this.validity = sensorDataValid || actuatorDataValid;


      }, (e) => {
        if (e.error.errorCode === 'E1011') {
          this.error = 'Device Not Found';
        }
        this.spinner.hide();
      })

  }

  getFormattedRawData(): string {
    if (this.isRawDataError) return '';
    return this.rawData + (this.rawActuatorData ? '*' + this.rawActuatorData : '');
  }

  deviceRowData(value) {
    if (!value || typeof value !== 'string') {
      return [];
    }
    value = value.replace('*', ';');
    if (value) {
      var rawData = value.split(';')
      var splitRawData = rawData ? rawData.filter(value => value != "") : ""
      var innerSplit = splitRawData.map((item) => {
        if (item.includes('|')) {
          var newInnerSplit = item.split('|')
          return newInnerSplit.map(i => i.split(':')[0])
        } else {
          return item.split(':')[0]
        }
      })
      var inputRawData = innerSplit.flat().map(i => i)
      this.sensorValue = splitRawData.map(i => i.split(':')).map(i => parseFloat(i[1]))
      return inputRawData
    }
  }

  checkInputDataValidity() {
    let inputValue = document.getElementById('inputRawData') as HTMLInputElement;
    let inputFormat = this.deviceRowData(inputValue.value)
    var validation = !this.sensorValue.some(n => {
      return Number.isNaN(n)
    })
    console.log(this.lastRawDataValidation(inputFormat, this.deviceRowData(this.expectedFormat)), validation)

    const actuatorInput = document.getElementById('inputRawActuatorData') as HTMLInputElement;
    const actuatorFormat = actuatorInput ? this.deviceRowData(actuatorInput.value) : [];

    const isSensorValid = this.lastRawDataValidation(inputFormat, this.deviceRowData(this.expectedFormat));
    const isActuatorValid = this.lastRawDataValidation(actuatorFormat, this.deviceRowData(this.expectedFormat));

    this.inputValidation = (isSensorValid || isActuatorValid) && validation;

  }

  lastRawDataValidation(array1, array2) {
    if (!Array.isArray(array1) || !Array.isArray(array2)) {
      return false;
    }

    let areArraysEqual
    const sortedArray1 = array1.slice().sort()
    const sortedArray2 = array2.slice().sort()
    if (sortedArray1.includes('DT') || sortedArray1.includes('ZZ')) {
      areArraysEqual = sortedArray1.some((element, index) => element === sortedArray2[index]);
    } else {
      if (sortedArray1.length === sortedArray2.length) {
        areArraysEqual = sortedArray1.every((element, index) => element === sortedArray2[index]);
      }
    }

    return areArraysEqual
  }

  splitArray(data) {
    var arraySplit = data.split(';')
    const innerSplit = arraySplit.map(item => item.split(/[-:]/))
    return innerSplit.map(item => {
      return item[1]
    }).slice().sort()

  }

  createExpectedMessageFormat(sensors, actuators) {
    if (sensors.length === 0 && actuators.length === 0) {
      this.expectedFormat = 'There is no sensor or actuators connected.';
    } else {
      const parseRawData = (raw) => {
        const dataMap = {};
        if (!raw) return dataMap;
        const items = raw.replace('*', '').split(';').filter(Boolean);
        items.forEach(item => {
          const parts = item.split(':');
          if (parts.length === 2) {
            const code = parts[0].split('-')[1];
            const value = parseFloat(parts[1]) || 0;
            if (code) dataMap[code] = value;
          }
        });
        return dataMap;
      };

      const sensorValue = {
        ...parseRawData(this.rawData),
        ...parseRawData(this.rawActuatorData)
      };

      const sensorFormat = this.connectedSensor.map((device, index) => {
        const value = sensorValue[device] !== undefined ? sensorValue[device] : 0;
        return `${index}-${device}:${value}`;
      }).join(';');
      
      const actuatorFormat = this.connectedActuator.map((device, index) => {
        const value = sensorValue[device] !== undefined ? sensorValue[device] : 0;
        return `${index}-${device}:${value}`;
      }).join(';');

      if (sensorFormat && actuatorFormat) {
        this.expectedFormat = sensorFormat + '*' + actuatorFormat;
      } else {
        this.expectedFormat = sensorFormat + actuatorFormat;
      }
    }
  }

  getDataFromFirebase() {
    const data = this.firebase.list('devices/' + this.deviceId).valueChanges();
    const deviceDetails = this.firebase.object('deviceDetails/' + this.deviceId).valueChanges();

    deviceDetails.subscribe((details: any) => {
      if (details) {
        this.rawData = details.lastRawData || '';
        this.rawActuatorData = details.lastRawActuatorData || '';

        this.deviceRowData(this.rawData);
        this.isRawDataError = !this.rawData && !this.rawActuatorData;

        this.validity = this.lastRawDataValidation(
          this.deviceRowData(this.rawData),
          this.deviceRowData(this.expectedFormat)
        ) || this.lastRawDataValidation(
          this.deviceRowData(this.rawActuatorData),
          this.deviceRowData(this.expectedFormat)
        ) || this.lastRawDataValidation(
          this.deviceRowData(this.rawData + '*' + this.rawActuatorData),
          this.deviceRowData(this.expectedFormat)
        );
      }
    });

    data.subscribe((item) => {
      this.newSensorData = item;
      this.newSensorData.forEach((sensor) => {
        const dateObject = new Date(sensor.time.millis);
        const timeObject = dateObject.toTimeString().split(/\s/)[0];
        const dateStr = formatDate(dateObject, 'yyyy-MM-dd', 'lk');
        const dateTime = dateStr + ' ' + timeObject;
        sensor.time = dateTime;
        this.currentTime = sensor.time;
      });
    });

    this.spinner.hide();
  }

}
